<template>
  <Card
    :class="$style.card"
    noBorder
    :style="backgroundColor"
  >
    <HeadingLarge
      v-if="hasLargeHeading"
      :class="$style.heading"
      :hasMargin="false"
    >
      {{ title }}
    </HeadingLarge>
    <HeadingMedium
      v-else
      :class="$style.heading"
      :hasMargin="false"
    >
      {{ title }}
    </HeadingMedium>
    <template v-slot:body>
      <div
        :class="[
          columns > 1? $style.contentCol : '',
          columns === 2? $style.col_2 : columns === 3? $style.col_3 : ''
        ]"
      >
        <slot />
      </div>
    </template>
  </Card>
</template>

<script>
import {
  Card,
  HeadingLarge,
  HeadingMedium,
} from '@jumpcloud/ui-components';

export default {
  name: 'ReportSection',

  components: {
    Card,
    HeadingLarge,
    HeadingMedium,
  },

  props: {
    background: {
      type: String,
      default: '',
    },
    columns: {
      type: Number,
      default: 1,
      validator: (columns) => {
        let isValid = true;

        if (columns < 1 || columns > 3) {
          isValid = false;
        }

        return isValid;
      },
    },
    hasLargeHeading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    backgroundColor() {
      return this.background ? `--bg-color: var(${this.background})` : '';
    },
  },
};
</script>

<style module scoped>
  .card.card {
    background-color: var(--bg-color);
    margin: var(--jc-size-3) 0;
  }

  .card.card:first-child { margin: 0; }

  .card.card .heading.heading {
    border-bottom: var(--jc-border-width-double) solid var(--jcGrey900);
    margin-bottom: var(--jc-spacer-large);
    padding-bottom: var(--jc-spacer-small);
  }

  .contentCol {
    display: grid;
  }

  .col_2 {
    column-gap: var(--jc-size-4);
    grid-template-columns: 1fr 1fr;
  }

  .col_3 {
    gap: var(--jc-size-2p75) var(--jc-size-3p5);
    grid-template-columns: repeat(3, 1fr);
  }

  .stat {
    display: flex;
    justify-content: space-between;
  }
</style>
